module.exports = __webpack_public_path__ + "images/0bb84db2c6a54cec90d6161c977bccf9Watson.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Watson.png
// module id = 0FaN
// module chunks = 0